import React from 'react';
import { LegalLayout } from '@/components/layout/LegalLayout';

export function TermsPage() {
  return (
    <LegalLayout title="Terms of Service" lastUpdated="May 12, 2026">
      <h2>1. The Editorial Guild</h2>
      <p>
        By accessing the DocForge Scriptorium, you enter a binding agreement with the Editorial Guild. You are granted a non-exclusive license to utilize the AI Forge for the creation of digital manuscripts.
      </p>

      <h2>2. Manuscript Ownership</h2>
      <p>
        The Guild recognizes the scribe as the primary author of all generated content. However, the structural density and algorithmic foundations of the Scriptorium remain the intellectual property of DocForge.
      </p>

      <h2>3. Code of Conduct</h2>
      <p>
        Every scribe must utilize the Forge for noble purposes. The generation of malicious scripts, false propaganda, or manuscripts intended to harm the collective knowledge is strictly prohibited.
      </p>

      <h2>4. Computational Credits</h2>
      <p>
        The utilization of the Scriptorium Engine requires computational energy. Users must maintain a positive balance of credits or hold an active Guild Membership to access advanced editorial models.
      </p>

      <h2>5. Archival Liability</h2>
      <p>
        While the Scriptorium utilizes redundant digital vaults, the Guild is not liable for the loss of manuscripts due to catastrophic database anomalies or unauthorized breach of a scribe's credentials.
      </p>
    </LegalLayout>
  );
}
